import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOhgarTextAndFloatingBannerComponent } from './custom-ohgar-text-and-floating-banner.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CustomOhgarTextAndFloatingBannerComponent],
  exports: [CustomOhgarTextAndFloatingBannerComponent],
    imports: [
        CommonModule,
        I18nModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                OhgarTextAndFloatingBannerComponent: {
                    component: CustomOhgarTextAndFloatingBannerComponent,
                },
            },
        } as CmsConfig),
        RouterModule,
    ]
})
export class CustomOhgarTextAndFloatingBannerModule { }
